<mbs-card-group>
  <mbs-form-group>
    <mbs-select
      [attr.data-e2e]="e2eLocators.authType"
      [bindLabel]="'label'"
      [bindValue]="'value'"
      [boldLabel]="true"
      [clearable]="false"
      [formControl]="authTypeControl"
      [hint]="hint"
      [items]="authTypes"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.authenticationType' | i18next">
      <ng-template #hint>
        @if (authType === AuthType.MBS) {
          <span>{{ 'storages:addStorageAccountWizard.inputCredentialsStep.wasabiAuthTypeMBSHintStart' | i18next }}</span>
          <ng-container
            *ngTemplateOutlet="
              permissionsRef;
              context: { label: 'storages:addStorageAccountWizard.inputCredentialsStep.minimumRequiredPermissions' | i18next }
            "></ng-container>
          <span>{{ 'storages:addStorageAccountWizard.inputCredentialsStep.wasabiAuthTypeMBSHintEnd' | i18next }}</span>
        }

        @if (authType === AuthType.Manual) {
          <span [innerHTML]="manualHint | i18next: { helpLink: createRoleHelpLink } | safe: 'html'"></span>
        }

        @if (authType === AuthType.Legacy) {
          <span>{{ 'storages:addStorageAccountWizard.inputCredentialsStep.wasabiAuthTypeLegacyHintStart' | i18next }}</span>
          <ng-container
            *ngTemplateOutlet="
              permissionsRef;
              context: { label: 'storages:addStorageAccountWizard.inputCredentialsStep.wasabiPolicy' | i18next }
            "></ng-container>
          <span>{{ 'storages:addStorageAccountWizard.inputCredentialsStep.wasabiAuthTypeLegacyHintEnd' | i18next }}</span>

          @if (isHelpAllowed) {
            <span
              [innerHTML]="
                'storages:addStorageAccountWizard.inputCredentialsStep.wasabiAuthTypeLegacyHintTutorial'
                  | i18next: { helpLink: createUserHelpLink }
                  | safe: 'html'
              "></span>
          }
        }
      </ng-template>
    </mbs-select>
  </mbs-form-group>

  @if (authType === AuthType.MBS || authType === AuthType.Legacy) {
    <mbs-form-group>
      <mbs-input
        [attr.data-e2e]="e2eLocators.accessKey"
        [autocomplete]="'new-password'"
        [boldLabel]="true"
        [formControl]="accessKeyControl"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.accessKey' | i18next"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.accessKey' | i18next"
        [showRequiredMark]="false"></mbs-input>
    </mbs-form-group>
    <mbs-form-group>
      <mbs-input-password
        [attr.data-e2e]="e2eLocators.secretKey"
        [autocomplete]="'new-password'"
        [boldLabel]="true"
        [disabledEye]="secretKeyControl.value === fakeSecretKey"
        [formControl]="secretKeyControl"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.secretKey' | i18next"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.secretKey' | i18next"
        [showRequiredMark]="false"></mbs-input-password>
    </mbs-form-group>
  }

  @if (authType === AuthType.Manual) {
    <mbs-form-group>
      <mbs-input-label
        [boldLabel]="true"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.providerID' | i18next"></mbs-input-label>
      @if (id; as id) {
        <mbs-clipboard [content]="id" />
      }
    </mbs-form-group>

    <mbs-form-group>
      <mbs-input
        [attr.data-e2e]="e2eLocators.arnRole"
        [boldLabel]="true"
        [formControl]="arnRoleControl"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.roleARN' | i18next"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.roleARN' | i18next"
        [showRequiredMark]="false"></mbs-input>
    </mbs-form-group>
  }
</mbs-card-group>

<!-- Same phrase either points at the help article or opens the policy modal, depending on the help permission -->
<ng-template
  #permissionsRef
  let-label="label">
  @if (isHelpAllowed) {
    <a
      class="mx-1"
      target="_blank"
      [helpLink]="'/billing-storage/storage-providers/wasabi/granular-permissions'">
      {{ label }}
    </a>
  } @else {
    <mbs-button
      [attr.data-e2e]="e2eLocators.minimumRequiredPermissionsBtn"
      [isCtrl]="true"
      [size]="mbsSize.sm"
      (click)="openMinimumRequiredPermissionsModal()">
      {{ label }}
    </mbs-button>
  }
</ng-template>
